<template>
  <CCard class="dataTable dataTable--hiddenHeader dataTable--TemplateEmail py-5 mt-3">
    <CRow class="pt-5 pb-4">
      <CCol sm="12" class="d-flex flex-column">
        <div>
          <h1 class="titlePage font-weight-normal text-capitalize">
            {{ $t('templates.email.list.title') }}
          </h1>
        </div>
      </CCol>
    </CRow>
    <CRow class="my-4">
      <CCol sm="12" v-if="totalRecords == 0 && !tableFilterValue">
        <EmptyList
          :loading="loadingGetList"
          :linkText="$t('templates.sms.list.button.createTemplateEmail')"
          :linkTo="{ name: 'new-template-list' }"
          :title="$t('templates.sms.list.text.noTemplateEmail')"
          :subTitle="$t('templates.sms.list.text.createEmail')"
        />
      </CCol>
      <CCol sm="12" v-if="totalRecords > 0 || !!tableFilterValue">
        <CCardHeader class="dataTable__header d-flex justify-content-between px-0 pb-5">
          <div class="dataTable__search">
            <CInput
              type="search"
              :placeholder="$t('templates.email.input.placeholder.search')"
              addInputClasses="pl-5"
              class="iconSearchPlaceholder pb-0"
              v-model="tableFilterValue"
            >
            </CInput>
          </div>
          <div class="dataTable__buttonLink">
            <router-link class="btn btn-primary px-4 py-3 font-weight-bold text-uppercase" tag="button" :to="{ name: 'new-template-list' }">{{
              $t('templates.email.list.buttons.new-template')
            }}</router-link>
          </div>
        </CCardHeader>

        <transition name="fade">
          <MenssageAlert :messages="messages" />
        </transition>

        <HeaderActions
          :show="{
            checkItems: true,
            manage: false,
            filterBy: false,
            orderByDate: {
              type: 'edited',
              show: true,
            },
            delete: true
          }"
          :multiSelect="true"
          :itemsListSelected="Boolean(itemsListSelected.length)"
          @confirm="deleteItemsSelected"
          @checkAll="checkAll"
          @deleteAll="deleteAll"
          @filterBy="chooseFilterBy"
          @sortByDate="sortByDate"
        />

        <CCardBody class="dataTable__body p-0">
          <CDataTable
            :items="registers"
            :fields="headers"
            :table-filter="{ external: true, lazy: true }"
            :table-filter-value.sync="tableFilterValue"
            items-per-page-select
            :items-per-page.sync="itemsPerPage"
            @pagination-change="paginationChange"
            :active-page="1"
            hover
            :loading="loading"
          >
            <template #loading>
              <div class="d-flex justify-content-center align-items-center dataTable__loading">
                <CSpinner class="my-3" color="primary" />
              </div>
            </template>

            <template #select="{ item }">
              <td @click.stop="" style="width: 60px" height="150">
                <div style="height: 145px" class="d-flex flex-column justify-content-center">
                  <CInputCheckbox class="text-center checkboxTable" :checked="item._selected" @update:checked="() => check(item)" custom />
                </div>
              </td>
            </template>

            <template #name="{ item }">
              <td height="150" width="200px">
                <div class="py-3 d-flex align-items-center h-100" @click.stop="openModal(item)">
                  <figure class="img-crop d-flex align-items-center m-0">
                    <img v-if="item.thumbnailUri" :src="item.thumbnailUri" alt="" width="80" height="auto" />
                  </figure>
                  <h5 class="font-weight-normal px-4">{{ item.name }}</h5>
                </div>
              </td>
            </template>

            <template #lastUpdatedBy="{ item }">
              <td height="150" width="500px">
                <div class="py-3 d-flex justify-content-center align-items-center h-100">
                  <p class="m-0">
                    {{ $t('templates.list.last-edited-on') }}
                    <span class="px-2">
                      {{ formatDate(new Date(item.updatedDateTime).toISOString()) }}
                    </span>
                    by
                    <span class="px-2">{{ item.lastUpdatedBy }}</span>
                  </p>
                </div>
              </td>
            </template>

            <template #actions="{ item }">
              <td class="text-center" width="230" height="150">
                <div class="d-flex justify-content-start align-items-center h-100">
                  <CDropdown
                    color="white"
                    :toggler-text="$t('templates.list.option.placeholder')"
                    class="border-gray-300 rounded"
                    :disabled="loadingOptions || item.showDelete"
                  >
                    <CDropdownItem @click="goToPage(item)" class="py-1">
                      <CIcon name="cilPencil" size="custom-size" :height="14" viewBox="0 0 32 32" class="mr-2" />
                      {{ $t('templates.list.option.edit') }}
                    </CDropdownItem>
                    <CDropdownItem class="py-1" @click="showDeletePopup(item)">
                      <CIcon name="cilTrash" size="custom-size" :height="14" viewBox="0 0 32 32" class="mr-2" />
                      {{ $t('templates.list.option.delete') }}
                    </CDropdownItem>
                    <CDropdownItem class="py-1" @click="duplicateEmailHandler(item.emailTemplateId)">
                      <CIcon name="cilCopy" size="custom-size" :height="14" viewBox="0 0 32 32" class="mr-2" />
                      {{ $t('templates.list.option.duplicate') }}
                    </CDropdownItem>
                  </CDropdown>

                  <transition name="fade" v-if="item.showDelete ? item.showDelete : false">
                    <div class="dataTable__popUp popUp popUp-delete">
                      <div class="popUp__body border-gray-300 rounded shadow-sm" style="max-width: 250px">
                        <div class="confirmationDelete">
                          <div class="confirmationDelete__header text-left h5 mb-3">{{ $t('templates.list.delete.header') }}</div>
                          <div class="confirmationDelete__body mb-4 text-left">{{ $t('templates.list.delete.text') }}</div>
                          <div class="confirmationDelete__footer">
                            <div class="mt-2">
                              <CButton
                                color="white"
                                class="py-2 px-3 mr-3 border-gray-300"
                                @click="
                                  () => {
                                    item.showDelete = false
                                    $forceUpdate()
                                  }
                                "
                              >
                                {{ $t('templates.list.delete.cancel') }}
                              </CButton>
                              <CButton color="primary" class="py-2 px-2" @click="deleteTemplate(item)">
                                {{ $t('templates.list.delete.confirm') }}
                              </CButton>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </transition>
                </div>
              </td>
            </template>
          </CDataTable>
        </CCardBody>

        <CPagination
          v-show="pages > 0 && totalRecords > 0"
          align="center"
          :pages="pages"
          :active-page.sync="activePage"
          class="dataTable__newPagination"
        >
          <template slot="previous-button">
            <span class="newPagination__button p-2 btnPagination">
              {{ $t('audience.audienceList.text.prev') }}
            </span>
          </template>
          <template slot="next-button">
            <span class="newPagination__button p-2 btnPagination">
              {{ $t('audience.audienceList.text.next') }}
            </span>
          </template>
        </CPagination>
      </CCol>
    </CRow>

    <CModal :title="modalData.name" color="secundary" :show.sync="modal" size="xl">
      <iframe
        :class="{ 'brightness-05': deleteModal }"
        :src="modalData.htmlFileUri"
        ref="iframeModal"
        width="100%"
        height="700px"
        frameborder="0"
      ></iframe>

      <template #footer>
        <div>
          <CButton
            class="mr-2 px-3"
            v-if="modalData.emailTemplateId"
            :disabled="loadingOptions"
            color="info"
            @click.stop="duplicateEmailHandler(modalData.emailTemplateId)"
          >
            <CIcon name="cilCopy" size="custom-size" :height="14" viewBox="0 0 32 32" />
            {{ $t('templates.email.list.duplicate') }}
          </CButton>
          <CButton class="mr-2 px-3" v-if="modalData.emailTemplateId" :disabled="loadingOptions" color="danger" @click.stop="toggleDeleteModal()">
            <CIcon name="cilTrash" size="custom-size" :height="14" viewBox="0 0 32 32" />
            {{ $t('templates.email.list.delete') }}
          </CButton>
          <CButton class="px-3" v-if="modalData.emailTemplateId" :disabled="loadingOptions" color="primary" @click.stop="goToPage(modalData)">
            <CIcon name="cilPencil" size="custom-size" :height="14" viewBox="0 0 32 32" />
            {{ $t('templates.email.list.edit') }}
          </CButton>
        </div>
      </template>
      <transition name="fade" v-if="deleteModal">
        <div class="dataTable__popUp popUp popUp--top centralize-popup" @click.stop.stop>
          <div class="popUp__body shadow-sm">
            <ConfirmationDelete
              :title="$t('templates.email.list.deleteModal.title')"
              :description="$t('templates.email.list.deleteModal.description')"
              :loadingConfirm="isLoadingDeleteModalConfirm"
              @cancel="toggleDeleteModal"
              @confirm="confirmDelete"
            />
          </div>
        </div>
      </transition>
    </CModal>
  </CCard>
</template>

<script>
import EmptyList from '@/components/EmptyList'
import HeaderActions from '@/components/table/HeaderActions'
import MenssageAlert from '@/components/MenssageAlert'
import { dateFormatStringFull } from '../../../utils/dateUtil'
import services from '@/services.js'
import fileDownload from 'js-file-download'
import ConfirmationDelete from '@/components/ConfirmationDelete'

export default {
  name: 'TemplateListEmail',
  components: {
    EmptyList,
    HeaderActions,
    MenssageAlert,
    ConfirmationDelete,
  },
  data() {
    return {
      loadingOptions: false,
      loadingGetList: false,
      columnFilterValue: {},
      tableFilterValue: null,
      orderByEdit: 2,
      loadedItems: [],
      loading: false,
      itemsPerPage: 10,
      pages: 0,
      headers: [],
      headersShow: ['name', 'lastUpdatedBy'],
      totalPendings: 0,
      totalRecords: 0,
      itemsListSelected: [],
      activePage: 1,
      responsive: false,
      messages: [],
      templateStatusId: null,
      OrganizationStatusId: null,
      collapseDuration: 0,
      details: [],
      modal: false,
      modalData: '',
      deleteModal: false,
      pagination: [],
      isLoadingDeleteModalConfirm: false,
    }
  },

  created() {
    this.loadingGetList = true
    this.getData({
      page: this.activePage,
      count: this.itemsPerPage,
      name: this.tableFilterValue,
      sort: this.orderByEdit,
      SortField: 'updatedDateTime', // ordenação fixa por update
    })
  },

  mounted() {
    ;(this.modal = false), (this.modalData = '')
  },

  watch: {
    reloadParams() {
      this.onTableChange()
    },
  },

  computed: {
    registers() {
      return this.loadedItems.map((template) => {
        return {
          ...template,
          _selected: this.itemsListSelected.includes(template.emailTemplateId),
          _classes: [template._classes, template._selected || this.itemsListSelected.includes(template.emailTemplateId) ? 'table-selected' : ''],
        }
      })
    },
    reloadParams() {
      return [this.activePage, this.itemsPerPage, this.tableFilterValue, this.orderByEdit]
    },

    detailPagination() {
      const first = (this.activePage - 1) * this.itemsPerPage
      const totalPage = this.activePage * 10 > this.totalRecords ? this.totalRecords : this.activePage * 10
      return `${first} - ${totalPage} ${this.$t('general.components.table.pagination.separate-numbers')} ${this.totalRecords}`
    },
  },

  methods: {
    showDeletePopup(item) {
      item.showDelete = true
      this.$forceUpdate()
    },
    deleteTemplate(item) {
      this.messages = []
      let templates = { data: [item.emailTemplateId] }

      let organizationId = this.$route.params.organizationId
      this.loadingOptions = true
      services
        .deleteTemplatesEmail(organizationId, templates)
        .then(() => {
          this.messages.push({
            status: 'success',
            text: this.$t('templates.list.delete.success') || 'Success',
          })
          this.onTableChange()
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response?.data?.message,
          })
        })
        .finally(() => {
          item.showDelete = false
          this.$forceUpdate()
          this.loadingOptions = false
        })
    },
    duplicateEmailHandler(templateId) {
      this.messages = []
      let organizationId = this.$route.params.organizationId

      this.loadingOptions = true

      services
        .duplicateEmail(organizationId, templateId)
        .then((res) => {
          this.goToPage(res.data.data)
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response?.data?.message,
          })
        })
        .finally(() => {
          this.loadingOptions = false
        })
    },
    goToPage(item) {
      const hasHTMLBuilderData = item.htmlBuilderData && Object.keys(item.htmlBuilderData).length !== 0

      if (hasHTMLBuilderData) {
        return this.$router.push({ name: 'unlayer', params: { templateId: item.emailTemplateId } })
      }
      this.$router.push({ name: 'edit-template-html', params: { id: item.emailTemplateId } })
    },

    openModal(item) {
      if (item.htmlFileUri) {
        this.modal = true
        this.modalData = item
      }
    },

    toggleDeleteModal() {
      this.deleteModal = !this.deleteModal
    },

    async confirmDelete() {
      try {
        this.isLoadingDeleteModalConfirm = true
        const organizationId = this.$route.params.organizationId
        await services.deleteTemplatesEmail(organizationId, { data: [this.modalData.emailTemplateId] })
      } catch ({ response }) {
        this.messages.push({
          status: 'danger',
          text: response?.data?.message,
        })
      } finally {
        this.modal = false
        this.deleteModal = false
        this.isLoadingDeleteModalConfirm = false
        this.onTableChange()
      }
    },

    headerHandle(arr) {
      let header = []
      let list = arr[0]
      try {
        for (const item in list) {
          if (this.headersShow.includes(item)) {
            header.push({
              key: `${item}`,
              label: '',
              _classes: 'hidde',
            })
          }
        }

        header.unshift({
          key: 'select',
          label: '',
          _classes: 'hidde',
          _style: 'width:60px',
        })

        header.push({
          key: 'actions',
          label: '',
          _classes: 'hidde',
          _style: 'width:150px',
        })

        return header
      } catch (error) {
        this.messagesSend.push({
          status: 'danger',
          text: error.response.data.message || 'ERROR',
        })
      }
    },

    mountItemsTable(arr) {
      return arr.reduce((acc, cur, index) => {
        acc.push({
          ...cur,
          index: index,
          _classes: [cur._classes, cur._selected ? 'table-selected' : ''],
        })
        return acc
      }, [])
    },

    getData(data) {
      this.loading = true
      let organizationId = this.$store.state.auth.organizationId
      services
        .templatesEmail(organizationId, { params: data })
        .then((templates) => {
          // this.pages = templates.data.data.pagination.totalPages / ;
          this.pages = Math.ceil(templates.data.data.pagination.totalRecords / 10)
          this.totalPendings = templates.data.data.totalPending
          this.totalRecords = templates.data.data.pagination.totalRecords
          this.activePage = templates.data.data.pagination.currentPage
          this.headers = this.headerHandle(templates.data.data.templates)
          this.loadedItems = this.mountItemsTable(templates.data.data.templates)
          this.pagination = templates.data.data.pagination
        })
        .catch(() => {
          this.loadedItems = []
          this.totalRecords = 0
        })
        .finally(() => {
          this.loading = false
          this.loadingGetList = false
        })
    },

    onTableChange() {
      this.loading = true
      this.getData({
        page: this.activePage,
        count: this.itemsPerPage,
        name: this.tableFilterValue,
        sort: this.orderByEdit,
        SortField: 'updatedDateTime', // ordenação fixa por update
      })
    },

    formatDate(date) {
      return dateFormatStringFull(date)
    },

    paginationChange(a) {
      this.itemsPerPage = a
    },

    check(item) {
      const val = Boolean(this.loadedItems[item.index]._selected)
      this.$set(this.loadedItems[item.index], '_selected', !val)
      this.checkedItem(item.emailTemplateId)
    },

    checkedItem(id = '') {
      if (this.itemsListSelected.includes(id)) {
        this.itemsListSelected = this.itemsListSelected.filter((item) => item !== id)
        return
      }

      this.itemsListSelected.push(id)
    },

    checkedAllitems(state) {
      if (!state) {
        this.itemsListSelected = []
        return
      }

      this.itemsListSelected = this.loadedItems.reduce((acc, cur) => {
        acc.push(cur.emailTemplateId)
        return acc
      }, [])
    },

    checkAll(state) {
      this.loadedItems.map((item) => {
        this.$set(this.loadedItems[item.index], '_selected', state)
      })

      this.checkedAllitems(state)
    },

    deleteAll() {
      let organizationId = this.$store.state.auth.organizationId
      services
        .deleteTemplatesEmail(organizationId, { data: this.itemsListSelected })
        .then(() => {
          this.loadedItems = []
          this.totalRecords = []
          this.onTableChange()
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
        })
    },

    deleteItemsSelected() {
      this.messages = []
      let organizationId = this.$store.state.auth.organizationId

      services
        .deleteTemplatesEmail(organizationId, { data: this.itemsListSelected })
        .then(({ data }) => {
          this.onTableChange()

          this.messages.push({
            status: 'success',
            text: data.message ? data.message : 'selected items have been deleted',
          })

          setTimeout(() => {
            this.itemsListSelected = []
          }, 1000)
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
        })
    },

    chooseFilterBy(item) {
      this.templateStatusId = null
      this.OrganizationStatusId = null

      if (item === 'all') {
        return
      }

      this[item.column] = item.value
    },

    downloadDoc(fileName, originalFileName) {
      this.messages = []
      let organizationId = this.$store.state.auth.organizationId

      services
        .getDownloadDocSender(organizationId, fileName)
        .then((response) => {
          fileDownload(response.data, originalFileName, response.headers['content-type'])

          this.messages.push({
            status: 'success',
            text: response.data.message || 'Success',
          })
        })
        .catch((error) => {
          this.messages.push({
            status: 'danger',
            text: error.response.data.message,
          })
        })
    },

    sortByDate(orderByEdit) {
      this.orderByEdit = orderByEdit ? 1 : 2
    },
  },
}
</script>

<style lang="scss" scoped>
.img-crop {
  width: 80px;
  height: 120px;
  overflow: hidden;
}

.centralize-popup {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.brightness-05 {
  filter: brightness(0.5);
}
</style>

<style module>
.blockClick {
  pointer-events: none;
}
</style>
<style>
.popUp-delete {
  position: relative !important;
  margin-top: -90px !important;
  margin-left: -80px !important;
}
</style>
